import React, { useEffect, useState } from "react";
import * as CONSTANTS from '../../utils/CONSTANTS'
import {makeSideBarActive } from '../../utils/EllowUtils';
import Styles from "./styles.module.scss";
import Button from "../../components/button";
import DropDown from '../../components/dropdown';
import { Icon } from "@iconify/react"; 
import {
  Grid,
  GridCellProps,
  GridColumn as Column,
  GridDetailRowProps,
  GridExpandChangeEvent,
} from "@progress/kendo-react-grid";
import classnames from "classnames"; 
import crownIcon from "../../assets/images/crown_gray_icon.svg";
import ResourceInfoModal from '../../modal/resourceInfo/index';
import { checkHrEmail } from '../../utils/EllowUtils'
import PopOver from "../../components/popover";
import file_download from "../../assets/images/file_download.svg"
import { REACT_APP_CANDIDATE_FRELLANCER } from "../../utils/common";
import { postAPI } from "../../api/api";

function InContractTab(props:any) {
  const userLoginId = localStorage.getItem('loginId')
  const menu = makeSideBarActive(CONSTANTS.sideMenu, 3)

  const [loginId , setloginId] = useState<any>()
  const [incontractList, setIncontractlist] = useState<any>()
  const [selected, setSelected] = useState<number>(0)
  const [show, setShow] = useState<boolean>()
  const [count , setCount] = useState<any>()
  const [pageSize , setPageSize] = useState<number>(25)
  const [pageNumber , setPageNumber] = useState<number>(1)
  const [infoModal , setInfoModal] = useState<boolean>(false)
  const [candidateJobId , setCandiateJobId] = useState<string>('')
  const [expand, setExpand] = useState<boolean>(false)
  const [rowNumber, setRowNumber] = useState<number>()
  const [hrEmail, setHrEmail] = useState<boolean>()
  const [prevCandidateJobId, setPrevCandidateJobId] = useState<string>('')
  const [prevContract, setPrevContract] = useState<boolean>(false)
  const [version, setVersion] = useState<number>()
  const [showCertification, setShowCertification] = useState<boolean>(false)
  const [certifications, setCertifications] = useState<any>()

  useEffect(() => {
    setIncontractlist(props.data)
    setCount(props.total)
  }, [props])


  const datachange = (e: any) => {
    setPageSize(e.value)
    props.handlePageChange(e.value, pageNumber)
  }

  const pageChange = (decision: string) => {
    let page = pageNumber
    if (decision === 'Add'){
      setPageNumber(pageNumber + 1)
      page = page + 1
    }else {
      setPageNumber(pageNumber - 1)
      page = page - 1
    }
    props.handlePageChange(pageSize, page)
  }

  const downloadData = (item: any) => {
    
    let fileName=item.resumeFileName;
    let value = {
      "action":"getObject",
      "filename":fileName,
      "bucketName":"ellow-prod-doc-upload",
    };
    postAPI(REACT_APP_CANDIDATE_FRELLANCER +'/resume-signed-url',value).then((data) => {
      let signedUrl = data.url;
     fileName = decodeURIComponent(fileName.slice(36, fileName.length))  
    
    fetch(signedUrl).then((response: any) => {
      response.blob().then((blob: any) => {
          const fileURL = window.URL.createObjectURL(blob);
          let alink = document.createElement('a');
          alink.href = fileURL;
          alink.download =fileName;
          alink.click();
      })
  })
  });
  }
  


  const rowClick = (contractHistory: any) => {    
 
    setInfoModal(true)
    setCandiateJobId(contractHistory && contractHistory.candidateJobId)
 }

const checkStatus = (status: string) => {

  switch (status) {
    case 'EDIT':
      return {
        value: 'Original',
        class: 'userStatusGreen'
      }
    case 'EXTEND_CONTRACT':
      return {
        value: 'Extended',
        class: 'userStatusOrange'
      }
    case 'TERMINATE':
      return {
        value: 'Terminated',
        class: 'userStatusRed'
      }
    default:
      return {
        value: 'Original',
        class: 'userStatusGreen'
    }
  }
}

 const onCloseModals = () => {
   setInfoModal(false)
   props.onClick(loginId)
  }
  
  const dateConvert = (startDate: number, endDate: number) => {
    
    if (startDate && endDate) {
      return `${new Date(startDate).toDateString().slice(3)} - ${new Date(endDate).toDateString().slice(3)}`
    }
    else {
      return 'Not Mentioned'
    }
  }

  const openInNewTab = (url: any) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  }
  
  const redirection = (candidateLoginId: string) => {
    localStorage.setItem('candidateLoginId', candidateLoginId);
    localStorage.setItem('ResourcesCandidateLoginId', candidateLoginId);
    localStorage.setItem('ResourcesTab', '6');
    openInNewTab(`${window.location.origin}/createResources`)
  }

  const certificationCell = (data: any) => {
    let ellowScreeningCertifications = data
    let skillcombine = ellowScreeningCertifications && ellowScreeningCertifications.map((dataskill: any) => {
      return dataskill.skills && dataskill.skills.name;
    }
    ).join(",");
    return (
      <td>
        <div className={Styles.positionStstus}>
          <PopOver title={skillcombine}
            position="Bottom">
            {ellowScreeningCertifications && ellowScreeningCertifications.map((skillData: any, key: any) => {
              return (<div key={key} className={Styles.positionList}>   <span className={Styles.dotStatus}/><strong>{skillData.skills && skillData.skills.name} - {skillData.certificationType} </strong> </div>);
            })}
          </PopOver>
        </div>
      </td>
    )
  }
  return (
    <>
 
          <div className={Styles.companyList} >

            { infoModal && <ResourceInfoModal onClose={onCloseModals} candidateJobId={candidateJobId} prevCandidateJobId={prevCandidateJobId} allocatedTo={props.allocatedTo} getTableValues={() => props.getTablesValues()} closed={props.closed} hrEmail={hrEmail} prevContract={prevContract} version={version}/>}
            <div className="staticPagination">
              {/* k-disabled */}
        <a href=" " className={pageNumber === 1 ? "k-link k-pager-nav k-disabled" : "k-link k-pager-nav"} title="Go to the previous page">
          <span className="k-icon k-i-arrow-60-left" onClick={(e) => {pageChange('Remove'); e.preventDefault()}}></span>
        </a>
        <a href=" " className={((pageNumber - 1) * pageSize + 1 >= count || count <= pageSize) ? "k-link k-pager-nav k-disabled" : "k-link k-pager-nav"} title="Go to the next page">
            <span className="k-icon k-i-arrow-60-right" onClick={(e) => { pageChange('Add'); e.preventDefault()}}></span>
        </a>
        Rows per page: <DropDown data={[25, 50, 100]} defaultValue="25" onChange={(e: any) => datachange(e)}/> {`${pageNumber === 1 ? 1 : (pageNumber - 1) * pageSize + 1}-${count < pageSize ? count : pageSize < ((pageNumber - 1) * pageSize + 1) ? ((pageNumber) * pageSize)  : pageSize } of ${count}`}
      </div>
      {incontractList && incontractList.map((item: any, key:number) => {
        return(
          <div key={key} className={classnames((selected === key && show) ? Styles.itemActive : Styles.itemInactive)}>
              <div className={Styles.companyItem}>
                <div className={Styles.actionButton}>
                  {(selected === key && show) ? <Button onClick={() => { setShow((prev) => !prev); setSelected(key)}}><Icon icon="akar-icons:minus" /></Button>
                  : 
                  <Button onClick={() => { setSelected(key); setShow(true); props.onClick(item.loginId); setloginId(item.loginId); setHrEmail(checkHrEmail())}} ><Icon icon="akar-icons:plus" /></Button>
                 }        
                </div>
                <div className={classnames(Styles.infoCard, Styles.infoCardMain)} onClick={() => redirection(item.loginId)}>
                { item.googleProfileImage ? 
                  <figure><img src={item.googleProfileImage}/></figure> : 
                  <figure className={Styles.noImage}>{item.firstName && item.firstName[0]}{item.lastName && item.lastName[0]}</figure>}
                  <h2>{item.name}
                  <span>{item.phoneNumber ? item.email : ''}</span>
                  <span>{item.phoneNumber ? item.phoneNumber : ''}</span>
                    {/* <span>{item.skills && item.skills.toString() }</span> */}
                  </h2>
                  
                </div>
                <div className={Styles.infoCard}>
                  <figure className={Styles.iconFig}> <img src={crownIcon} /></figure>
                  <h4>
                    Work Experience
                  <span>{item.experience} Years</span>
                  </h4>
              </div>
              <div className={Styles.infoCard}>
                  <figure className={Styles.iconFig}> <img src={crownIcon} /></figure>
                  <h4>
                    Certifications
                    <span>{certificationCell(item.ellowScreeningCertifications)}</span>
                  </h4>
              </div>
                <div className={Styles.infoCard}>
                  <figure className={Styles.iconFig}><Icon icon="lucide:award" /></figure>
                  <h4>
                   ellow Status
                  <span>{item.ellowStatus}</span>
                  </h4>
              </div>
              <div className={Styles.infoCard}>
                  <figure className={Styles.iconFig}><Icon icon="lucide:award" /></figure>
                  <h4>
                   
                  <span>
                  <img src={file_download} onClick={() => downloadData(item)} alt='' className="downloadButton"/>
                  </span>
                  </h4>
              </div>
                
              </div>
              <div className={Styles.detailtable}>
                <section className="tableStyle no-padd-top">
                  <div className={Styles.expandableTable}>
                  <div className={Styles.tableItemWrap}>
                    <table>
                      <thead>
                        <tr>
                          <th></th>
                          <th className={Styles.width135}>Title</th>
                          <th className={Styles.width180}>Company</th>
                          <th className={Styles.width150}>Jobrole</th>
                          <th className={Styles.width180}>Duration</th>
                          <th className={Styles.width150}>Resources cost</th>
                          <th className={Styles.width150}>ellow rate</th>
                          <th>updated on</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td colSpan={9}  className={classnames(Styles.tdWrap, Styles.tdWrapActive)}>
                            {props.contractHistory && props.contractHistory.length > 0 && props.contractHistory.map((item: any, key: number) => {
                              return (
                                <>
                                <table>
                                  <tr>
                                    <td width="67">
                                    <span className={checkStatus(props.contractHistory[key].action).class}>{checkStatus(props.contractHistory[key].action).value}</span>
                                      <div className={Styles.expand}>
                                        <Icon key={key} icon={expand && key === rowNumber ? "ep:arrow-down-bold" : 'ep:arrow-up-bold'} onClick={() => { setExpand(!expand); setRowNumber(key)}} />
                                        </div>
                                    </td>
                                      <td width="135">{item.position}</td>
                                      <td width="180">{item.companyName}</td>
                                      <td width="150">{item.jobRole}</td>
                                      <td width="180">{dateConvert(parseInt(item.contractStartDate), parseInt(item.contractEndDate))} </td>
                                      <td width="150">{item.contractRate && `${item.contractRate} ${item.contractCurrencyType} /${item.contractBillingType}`}</td>
                                      <td width="150">{item.ellowRate && `${item.ellowRate} ${item.ellowCurrencyType} /${item.ellowBillingType}`}</td>
                                      <td>{new Date( parseInt(item.updatedOn)).toDateString().slice(3) }</td>
                                    <td>
                                      <div className={Styles.info}>
                                          <Icon icon="lucide:info" onClick={props.contractHistory[key].action === 'EXTEND_CONTRACT' ? () => { rowClick(props && props.contractHistory[key]); setPrevContract(false);  setPrevCandidateJobId(props.contractHistory[key - 1].candidateJobId);  } : () => { rowClick(props && props.contractHistory[key]); setPrevContract(false); setPrevCandidateJobId(props.contractHistory[key].candidateJobId) }}/>
                                      </div>
                                    </td>
                                  </tr>
                                </table>
                                 <div className={Styles.tableExpand}>
                                 { expand && key === rowNumber && <table>
                                      {item && item.historyList && item.historyList.length > 0 && item.historyList.map((history: any, key: number) => {
                                        return (
                                          <tr>
                                            <td width="135">{history.position}</td>
                                            <td width="180">{history.companyName}</td>
                                            <td width="150">{history.jobRole}</td>
                                            <td width="180">{dateConvert(parseInt(history.contractStartDate), parseInt(history.contractEndDate))} </td>
                                            <td width="150">{history.contractRate && `${history.contractRate} ${history.contractCurrencyType} /${history.contractBillingType}`}</td>
                                            <td width="150">{history.ellowRate && `${history.ellowRate} ${history.ellowCurrencyType} /${history.ellowBillingType}`}</td>
                                            <td>{new Date(parseInt(history.updatedOn)).toDateString().slice(3) }</td>
                                            <td>
                                            <div className={Styles.info}>
                                              <Icon icon="lucide:info" onClick={() => { rowClick(item.historyList[key]); setPrevContract(true); setVersion(key + 1)}}/>
                                            </div>
                                            </td>
                                        </tr>
                                     )
                                   }) }
                                 </table>}
                                  </div>
                                  </>
                              )
                            })
                            }   
                
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                </section>
              </div>
          
            </div>
        )
      })
    }
    </div>
    </>
  )
}

export default InContractTab